import { mdiClose, mdiFileRemoveOutline } from '@mdi/js';
import Icon from '@mdi/react';
import React from 'react';
import {
  Col,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  Spinner,
} from 'reactstrap';
import './CancelRequest.scss';
import { useNavigate } from 'react-router-dom';
import { Controller, useForm } from 'react-hook-form';
import { useMutation } from '@tanstack/react-query';
import { toast } from 'react-toastify';
import { rejectTravelBooking } from '../../../store/apis/travelService';

function CancelQuoteRequest({ isOpen, toggle, reqNo, revisionNo }) {
  const navigate = useNavigate();
  const {
    control,
    getValues,
    formState: { errors },
  } = useForm({
    defaultValues: {
      revisionRemarks: '',
    },
    mode: 'onChange',
  });

  const { mutate: cancelTravelMutate, isPending } = useMutation({
    mutationFn: payload => rejectTravelBooking(payload),
    onSuccess: response => {
      if (response?.flag === 'True') {
        toast.success('Travel request for quotation cancelled successfully.', {
          className: 'toast-success',
        });
        toggle();
        navigate('/travel-request');
      } else if (response?.flag === 'False') {
        if (response?.errorData && response?.errorData.length > 0) {
          response.errorData.forEach(error => {
            toast.error(error[0]['Error Message'], {
              className: 'toast-error',
            });
          });
        } else {
          toast.error(
            response?.message ||
              'Failed to cancel quotation request travel request.',
            {
              className: 'toast-error',
            },
          );
        }
      }
    },
    onError: error => {
      toast.error(
        error?.message ||
          'An error occurred while cancelling the quotation request.',
        {
          className: 'toast-error',
        },
      );
    },
  });

  const handleCancelTravelRequest = async () => {
    const { revisionRemarks } = getValues();
    if (!revisionRemarks) {
      toast.error('Please provide a reason for cancellation.', {
        className: 'toast-error',
      });
    } else {
      const payload = {
        reqNo,
        revisionNo: parseInt(revisionNo, 10),
        remarks: revisionRemarks,
        cancelType: 'Q',
      };

      cancelTravelMutate(payload);
    }
  };
  return (
    <Modal isOpen={isOpen} toggle={toggle} centered size="xs">
      <ModalBody>
        <div className="d-flex flex-row align-items-center justify-content-between mb-3">
          <div className="tr-cancel-icon">
            <Icon path={mdiFileRemoveOutline} size={0.7} />
          </div>
          <div>
            <button type="button" className="btn btn-link p-0" onClick={toggle}>
              <Icon path={mdiClose} size={1} />
            </button>
          </div>
        </div>
        <div>
          <h5>Cancel Quote Request</h5>
          <p>Are you sure you want to cancel this quote request?</p>
        </div>
        <Label>
          Reason<span className="text-danger">*</span>
        </Label>
        <Controller
          control={control}
          name="revisionRemarks"
          render={({ field }) => (
            <Input
              {...field}
              placeholder="Enter"
              type="textarea"
              rows="4"
              className="form-control external-filter-input"
            />
          )}
        />
        {errors.revisionRemarks && (
          <span className="text-danger">
            {errors.revisionRemarks.message || 'Reason is required.'}
          </span>
        )}
      </ModalBody>
      <ModalFooter>
        <Col>
          <button
            type="button"
            onClick={toggle}
            className="tr-cancel-btn w-100"
          >
            No
          </button>
        </Col>
        <Col>
          <button
            type="button"
            className="tr-confirm-btn w-100"
            onClick={handleCancelTravelRequest}
          >
            Yes, Cancel
            {isPending && (
              <>
                {' '}
                <Spinner size="sm" />
              </>
            )}
          </button>
        </Col>
      </ModalFooter>
    </Modal>
  );
}

export default CancelQuoteRequest;
